<ng-template #staticWorkerTemplate let-title="title" let-worker="worker">
  <div class="static-holder">
    <div class="title">{{ title }}</div>
    <div class="static-worker">
      <photo [size]="24" [data]="worker"></photo>
      <span class="name">{{worker.firstName}} {{worker.lastName}}</span>
    </div>
  </div>
</ng-template>


<div class="joi-dialog with-manage-workers">
  <div class="header">
    <div>{{ title }}</div>
    <icon (click)="close()" matIcon="close"></icon>
  </div>
  <div class="picker" [ngClass]="{include_all_option_selected:include_all_option_selected}">
    <div>
      <ng-container *ngIf="!!data.taskCreator" [ngTemplateOutlet]="staticWorkerTemplate" [ngTemplateOutletContext]="{worker: data.taskCreator, title: 'Created By'}" ></ng-container>
      <ng-container *ngIf="!!data.taskResponsiblePerson" [ngTemplateOutlet]="staticWorkerTemplate" [ngTemplateOutletContext]="{worker: data.taskResponsiblePerson, title: 'Responsibility'}" ></ng-container>
      <hr *ngIf="!!data.taskCreator || !!data.taskResponsiblePerson" />

      <div class="groups" *ngIf="!disableEveryoneInWorkforceOption">
        <div class="title">Permissions</div>
        <div>
          <div
            [ngClass]="{selected:selected['groups'] && selected['groups']['--all--']}"
            (click)="toggleSelected('groups', '--all--')"
            class="item is_all_option"
          >
            <div class="desc">
              <icon class="group" icon="group24"></icon>
              <span class="name">{{allGroupName}}</span>
              <div style="flex:1;"></div>
              <icon class="check" icon="tick24"></icon>
            </div>
          </div>
        </div>
      </div>
      <hr *ngIf="!disableEveryoneInWorkforceOption" />

      <!--<div *ngIf="!disableEveryoneInWorkforceOption" class="everyone-toggle-holder">
        {{ allGroupName }}
        <mat-slide-toggle (change)="toggleSelected('groups', '--all--')" [checked]="selected['groups'] && selected['groups']['--all--']"></mat-slide-toggle>
      </div>-->
      <div class="searchBarHolder" [ngClass]="{hidden: !possible_people.length && !possible_groups.length && !data.disallowNewWorker}"><search-bar [debounceTime]="0" [gray]="true" [placeholder]="'Search workforce'+(possible_groups.length > 0 ? ' or groups' : '')" (keyword)="onSearchInput($event)"></search-bar></div>
<!--       <div class="search">
        <mat-form-field class="general" *ngIf="possible_people.length > 0 || possible_groups.length > 0">
          <input matInput name="search" autocomplete="off" [(ngModel)]="search_input" #searchEl [placeholder]="'Search workforce member'+(possible_groups.length > 0 ? ' or group name' : '')" (keyup)="onSearchInput($event)" />
        </mat-form-field>
      </div> -->

      <div class="groups" *ngIf="possible_groups.length > 0 || !disableEveryoneInWorkforceOption">
        <div class="title" *ngIf="possible_groups.length && !disableEveryoneInWorkforceOption">Groups</div>
        <div>
          <div [ngClass]="{selected:selected['groups'] && selected['groups'][group.name]}" (click)="toggleSelected('groups',group.name)" class="item" *ngFor="let group of possible_groups">
            <div class="desc">
              <icon class="group" icon="group24"></icon>
              <span class="name">{{group.realName}}</span>
              <div style="flex:1;"></div>
              <icon class="check" icon="tick24"></icon>
            </div>
          </div>
        </div>
      </div>
      <div class="people" *ngIf="possible_people.length">
        <div class="title" *ngIf="possible_groups.length > 0 || !disableEveryoneInWorkforceOption">People</div>
        <div>
          <div [ngClass]="{selected:selected['people'] && selected['people'][person.email]}" (click)="toggleSelected('people',person.email)" class="item" *ngFor="let person of possible_people; index as idx">
            <div class="desc">
              <photo [size]="24" [data]="person"></photo>
              <div class="name-and-role">
                <span class="name">{{person.firstName}} {{person.lastName}}</span>
                <span *ngIf="person.role" class="name">,&nbsp;</span>
                <span *ngIf="person.role" class="role">{{person.role}}</span>
              </div>
              <div style="flex:1;"></div>
              <icon class="check" icon="tick24"></icon>
            </div>  
          </div>
        </div>
      </div>
      <div class="null_state" [ngClass]="{show:possible_people.length === 0 && possible_groups.length === 0 && !data.disallowNewWorker}">

        <!-- <div>We can't find anyone in your workforce <span *ngIf="search_input">matching this entry. Please fill out an email address for this user.</span></div> -->

        <!-- TODO:  Extract this part of manage workers into its own component, and figure out just how tightly this is coupled to manage workers -->
        <app-manage-workers #manageWorkers [fromPeoplePicker]="true" [emailinput]="searchBar.value" (completed)="manageWorkerComplete($event)"></app-manage-workers>
      </div>
    </div>
  </div>
  <div *ngIf='need_to_add' class="actions">
    <button class="no_margin" mat-button *ngIf="newWorkerStatus === newWorkerStages.email_address && !manageWorkers.selectedContacts.size " [disabled]="!newWorker?.email || !newWorker?.firstName || !newWorker?.lastName || workforceService.errorMessage != null" (click)="add(false)">ADD & INVITE LATER</button>
    <button mat-button color="primary" *ngIf="newWorkerStatus === newWorkerStages.email_address && !manageWorkers.selectedContacts.size " [disabled]="!newWorker?.email || !newWorker?.firstName || !newWorker?.lastName || workforceService.errorMessage != null" (click)="add(true)">CONTINUE</button>
    <button class="no_margin" mat-button *ngIf="!!manageWorkers.selectedContacts.size && !isInviting" (click)="add(false)">ADD & INVITE LATER</button>
    <button mat-button color="primary" *ngIf="!!manageWorkers.selectedContacts.size && !isInviting" (click)="add(true)">CONTINUE</button>
    <button mat-button color="primary" [disabled]="!workforceService.invite_valid" *ngIf="isInviting" (click)="send()">SEND</button>
  </div>
</div>
